import { sanitizeHtml } from '../functions'

/**
 * SelectTemplate // 選択肢作成のテンプレート
 *
 * @returns {undefined}
 */

class SelectTemplate {
  /**
   * select.
   *
   * @param {string} key
   * @param {string} value
   * @param {string} current
   * @param {boolean} disable
   */
  select(key, value, current, disable) {
    const selected = key === current ? 'selected' : ''
    const disabled = disable === true ? 'disabled' : ''
    key = sanitizeHtml(key)
    value = sanitizeHtml(value)
    return `<option value="${key}" ${selected} ${disabled}>${value}</option>`
  }

  /**
   * selectList // セレクトのリストを返す
   *
   * @param {array} selectList // 例 [{key: 'JAL', value: '日本航空'}] など
   * @param {string} current
   */
  selectList(selectList, current) {
    let html = ''
    for (const item of selectList) {
      let disable = false
      if (item.disable != null) {
        disable = item.disable
      }
      html += this.select(item.key, item.value, current, disable)
    }
    return html
  }
}

export default new SelectTemplate()
